// extracted by mini-css-extract-plugin
export var black = "_2e-6";
export var brand = "_2e-1";
export var ddefault = "_2e-0";
export var error = "_2e-3";
export var gray = "_2e-2";
export var highContrast = "_2e-8";
export var outline = "_2e-7";
export var success = "_2e-5";
export var warning = "_2e-4";